import styled, { css } from 'styled-components'
import { Spacings, Text } from '@styles'

const getStatusStyle = ({ status = '', theme }) => {

	const STATUS_MAP = {
		GOOGLE: {
			bg: theme.palette.background.pink,
			color: theme.palette.text.redTwo,
			border: theme.palette.text.pinkTwo,
		},
		FACEBOOK: {
			bg: theme.palette.background.blueLight,
			color: theme.palette.text.white,
			border: theme.palette.text.blue,
		},
		LINKEDIN: {
			bg: theme.palette.background.blueLight,
			color: theme.palette.text.white,
			border: theme.palette.text.blue,
		},
		EXHIBITION: {
			bg: theme.palette.background.green,
			color: theme.palette.text.primary,
			border: theme.palette.text.disabled,
		},
		COLD_CALLING: {
			bg: theme.palette.background.messageRed,
			color: theme.palette.text.white,
			border: theme.palette.text.disabled,
		},
		WEBSITE: {
			bg: theme.palette.background.Celeste,
			color: theme.palette.text.Celeste,
			border: theme.palette.text.CelesteTwo,
		},
		REFERRAL: {
			bg: theme.palette.background.pink,
			color: theme.palette.text.redTwo,
			border: theme.palette.text.pinkTwo,
		},
		WHATSAPP: {
			bg: theme.palette.background.Fog,
			color: theme.palette.text.Fog,
			border: theme.palette.text.FogTwo,
		},
		GOVT_TENDER_DATABASE: {
			bg: theme.palette.background.yellow,
			color: theme.palette.text.primary,
			border: theme.palette.text.disabled,
		},
		'AI AGENT': {
			bg: theme.palette.background.yellow,
			color: theme.palette.text.primary,
			border: theme.palette.text.disabled,
		},
	}

	const style = STATUS_MAP[status] || {
		bg: theme.palette.background.disabled,
		color: theme.palette.text.black,
		border: theme.palette.text.disabled,
	}

	return css`
		background: ${style.bg};
		color: ${style.color};
		border: 1px solid ${style.border};
	`
}

const StatusBadgeWrapper = styled.span`
	${getStatusStyle};

	font-size: ${Text.SMALL};
	padding: ${Spacings.SPACING_1B} ${Spacings.SPACING_3};
	border-radius: 4px; /* changed border-radius */
	display: inline-flex;
	align-items: center;
	font-weight: ${Text.BOLD_600};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

const StatusBadge = ({ label, status }) => {
	return <StatusBadgeWrapper status={status}>{label}</StatusBadgeWrapper>
}

export default StatusBadge
